import OrderAPICall from "../service/OrderAPICall";

class OrderRepository {

    fetchOrderList = async (keyword, searchType, timeSpan, start, pageSize, sortBy, sortOrder, filterByOption, continuationToken) => {
        return await new OrderAPICall().fetchOrderList({ keyword, searchType, timeSpan, start, pageSize, sortBy, sortOrder, filterByOption, continuationToken })
    };

    sendEmailSalesRepresentativeOrder = async (lineItemNumber, purchaseOrderNumber, orderNumber) => {
        return await new OrderAPICall().sendEmailSalesRepresentativeOrder({ lineItemNumber, purchaseOrderNumber, orderNumber });
    };

    sendOrderItemEmail = async (params) => {
        return await new OrderAPICall().sendOrderItemEmail(params);
    };

    placeYourOrder = async (params) => {
        return await new OrderAPICall().placeYourOrder(params);
    };

    fetchPlaceOrderItems = async (orderId) => {
        let orderDetail = await new OrderAPICall().fetchPlaceOrderItems(orderId);
        return orderDetail;
    };

    orderDownloadInvoice = async (invoiceNumber) => {
        return await new OrderAPICall().orderDownloadInvoice(invoiceNumber);
    };

    exportOrder = async (params) => {
        return await new OrderAPICall().exportOrder(params);
    };
    exportEmail = async (params) => {
        return await new OrderAPICall().exportEmail(params);
    };

    exportEmailSales = async (params) => {
        return await new OrderAPICall().exportEmailSales(params);
    };

    fetchOrderExportCount = async () => {
        return await new OrderAPICall().getExportOrderCount();
    };

    fetchManufacturerList = async () => {
        return await new OrderAPICall().fetchManufacturerList();
    };

    sendOrderPOLineItemEmail = async (params) => {
        return await new OrderAPICall().sendOrderPOLineItemEmail(params);
    };

    getValidateOrderFromServer = async (params) => {
        return await new OrderAPICall().getValidateOrderFromServer(params);
    };

    getOrderItemList = async (params) => {
        const res = await new OrderAPICall().getOrderItemList(params);
        const responses = {};

        if (res.data && res.data.length > 0) {
            responses[params?.id] = res.data;
        }

        return responses
    };

    billingCurrencyConversion = async (params) => {
        return await new OrderAPICall().billingCurrencyConversion(params);
    };

    fetchOrderDetail = async (params) => {
        const param = {}

        if (params.WebOrderId !== '') {
            param.WebOrderId = params.WebOrderId
        }
        if (params.SalesOrderNumber !== '') {
            param.SalesOrderNumber = params.SalesOrderNumber
        }
        return await new OrderAPICall().fetchOrderDetail(param);
    };

    orderCancellationEmail = async (params) => {
        return await new OrderAPICall().orderCancellationEmail(params);
    };
}

export default OrderRepository;